import { render, staticRenderFns } from "./TrustedPartner.vue?vue&type=template&id=48873988&"
import script from "./TrustedPartner.vue?vue&type=script&lang=js&"
export * from "./TrustedPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports